import React, { useState } from 'react';
import { auth } from '../../firebase';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import SettingsSidebar from './Sidebar';
import '../App.css';

const ChangePassword = ({ setPage }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const displayMessage = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(''), 4000);
  };

  const handleChangePassword = async () => {
    const user = auth.currentUser;

    if (!user || !oldPassword || !newPassword) {
      displayMessage('All fields are required.', 'error');
      return;
    }

    if (newPassword !== confirmNewPassword) {
      displayMessage("New passwords don't match.", 'error');
      return;
    }

    try {
      const credential = EmailAuthProvider.credential(user.email, oldPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      displayMessage('Password changed successfully.', 'success');
      setOldPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    } catch (err) {
      displayMessage(`Error: ${err.message}`, 'error');
    }
  };

  const styles = {
    container: { display: 'flex', minHeight: '100vh', background: 'linear-gradient(to right, #f8f9fa, #eef2f7)' },
    content: { flexGrow: 1, padding: '3rem', display: 'flex', justifyContent: 'center', alignItems: 'center' },
    card: {
      width: '100%',
      maxWidth: '500px',
      backgroundColor: '#fff',
      borderRadius: '16px',
      boxShadow: '0 6px 25px rgba(0,0,0,0.1)',
      padding: '2.5rem',
    },
    title: { textAlign: 'center', color: '#0d47a1', fontSize: '1.8rem', fontWeight: 700, marginBottom: '25px' },
    input: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      fontSize: '1rem',
      marginBottom: '15px',
      transition: 'all 0.2s ease',
    },
    inputFocus: { borderColor: '#007bff', boxShadow: '0 0 5px rgba(0,123,255,0.3)' },
    button: {
      width: '100%',
      padding: '12px 20px',
      borderRadius: '10px',
      border: 'none',
      backgroundColor: '#007bff',
      color: 'white',
      fontWeight: '600',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    messageBox: (type) => ({
      padding: '12px 18px',
      marginBottom: '20px',
      borderRadius: '8px',
      textAlign: 'center',
      color: type === 'error' ? '#721c24' : '#155724',
      backgroundColor: type === 'error' ? '#f8d7da' : '#d4edda',
      border: `1px solid ${type === 'error' ? '#f5c6cb' : '#c3e6cb'}`,
    }),
  };

  return (
    <div style={styles.container}>
      <SettingsSidebar currentPage="settings/password" setPage={setPage} />
      <div style={styles.content}>
        <div style={styles.card}>
          <h2 style={styles.title}>Change Password</h2>

          {message && <div style={styles.messageBox(messageType)}>{message}</div>}

          <input
            type="password"
            placeholder="Current Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            style={styles.input}
          />

          <button
            onClick={handleChangePassword}
            style={styles.button}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
          >
            Update Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
